module.exports = __webpack_public_path__ + "static/media/icon-360-degrees.0a7251bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/icon-360-degrees.png
// module id = 1488
// module chunks = 0